import styled, { createGlobalStyle } from 'styled-components';
import { prefix } from '../../tools/settings';
import { Dialog as BPDialog } from '@blueprintjs/core';
import { cssVar, rgba } from 'polished';
var Modal = styled(BPDialog).withConfig({
  displayName: "Modalstyles__Modal",
  componentId: "sc-1r1rixq-0"
})(["&.bp3-dialog{background:var(--dentsu-color-white);box-shadow:var(--dentsu-shadow-24);border-top:2px solid var(--dentsu-color-n150);border-radius:0;box-shadow:none;padding-bottom:0;width:", ";max-width:90vw;max-height:90vh;margin:0;&.", "-modal--fullheight{max-height:none;height:90vh;}&.", "-modal--fullwidth{max-width:none;width:calc(100% - 10vh);}}"], function (props) {
  return props.width ? props.width : '848px';
}, prefix, prefix);
var BPDialogStyles = createGlobalStyle([".bp3-overlay-backdrop{background-color:", ";}"], rgba(cssVar('--dentsu-color-black', '#05051e'), 0.75));
export var Styled = {
  BPDialogStyles: BPDialogStyles,
  Modal: Modal
};